import React, { useContext } from "react";
import "./billDetails.css";
import { MainTitle } from "../../../../components/mini-components/mini-components.jsx";
import BillTile from "./BillTile";
import CartContext from "../../../../context/cart_context";
import { Availability } from "../../../../models/Restaurent_food_model";
import { calculateOriginalPrice } from "../../../../functions/mini_func.js";

const BillDetails = () => {
  const { cartItems, selectedfoodItemList, couponAmount } =
    useContext(CartContext);

  var total = 0;

  if (selectedfoodItemList.length != 0) {
    Object.entries(cartItems).forEach(([key, value]) => {
      const item = selectedfoodItemList.find((item) => item.dbID == key);
      total =
        total +
        calculateOriginalPrice(item.discount, parseFloat(item.price)) * value;
    });
  }

  const gstAmount = () => {
    var total = 0;

    if (selectedfoodItemList.length != 0) {
      Object.entries(cartItems).forEach(([key, value]) => {
        const item = selectedfoodItemList.find((item) => item.dbID == key);
        if (item.gst == Availability.YES)
          total =
            total +
            calculateOriginalPrice(item.discount, parseFloat(item.price)) *
              value;
      });
    }

    return Math.round(total * 0.05);
  };

  return (
    <div className="checkout-item-container bill-container">
      <MainTitle title={"Bill Details"} />
      <BillTile name={"Sub total"} amount={total} />
      <BillTile name={"GST "} amount={gstAmount()} />
      <BillTile name={"Coupons"} amount={couponAmount} />
      <div className="dotted-border"></div>
      <BillTile
        name={"Payable Amount"}
        amount={total + gstAmount() - couponAmount}
      />
    </div>
  );
};

export default BillDetails;
